export default class UFRegion {
  public id: string = '';

  public sigla: string = '';

  public nome: string = '';

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.sigla = data.sigla || '';
    this.nome = data.nome || '';
  }
}
